import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "react-bootstrap";

import blogApi from "../../../api/blogApi";
import SideBlock from "../SideBlock";
import { lang } from "../../../config/lang";
import { Businesses } from "../../../config/Helper";
import store from "../../../store/configureStore";
import captionApi from "../../../api/captionApi";

class BlogSideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arrBlog: [],
      title: "",
    };

    this.lang = this.props.language.lang_key;
    this.id = this.props.id;
    const business = store.getState().blog.business;
    this.business = business;
    this.getBlogs = this.getBlogs.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    this.getBlogs();
    this.setState({ title: this.props.title });
  }

  componentDidUpdate() {
    window.playVideo();
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    // console.log("prevProps ", prevProps);
    if (this.props.title !== prevProps.title) {
      this.setState({ title: this.props.title });
    }
    // if (this.props.foreclose !== prevProps.foreclose) {
    //   this.setState({ isForeclosed: this.props.foreclose });
    // }
  }

  componentWillUnmount() {}

  componentWillReceiveProps(newProps) {
    // console.log("newProps ", newProps);
    if (
      this.lang !== newProps.language.lang_key ||
      this.business !== newProps.business ||
      this.id !== newProps.id
    ) {
      this.lang = newProps.language.lang_key;
      this.id = newProps.id;
      this.business = newProps.business;

      this.getBlogs();
      captionApi.getCaptions("blog_detail").then((json) => {
        if (json.status === 200) {
          this.setState({
            title: json.data[0].title,
          });
        } else {
        }
      });
    }
  }

  getBlogs() {
    const businessStore = store.getState().blog.business;
    blogApi.getSideBlogs(this.id, businessStore).then((json) => {
      if (json.status === 200 && json.data) {
        this.setState({
          arrBlog: json.data,
        });
      } else if (json.status !== 200) {
      }
    });
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-11 ml-auto">
          <div className="side-box" style={{ marginTop: "20px" }}>
            <h2 className="heading">{this.state.title}</h2>
            <ul className="post-list list-unstyled">
              {this.state.arrBlog.map((blog, key) => (
                <SideBlock
                  key={key}
                  business={blog.business}
                  id={blog.id}
                  title={blog.title}
                  image={blog.media_filename}
                  media_type={blog.media_filetype}
                  isListPage={false}
                />
              ))}
              <li>
                <Link
                  to={"/blog"}
                  className="btn btn-primary btn-outline-primary"
                >
                  {lang("view_all")}
                  <i className="ion-ios-arrow-forward"></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(BlogSideBar);
